<template>
  <div class="flow123">
    <div class="flow123-step">
      <NumberCircle :disabled="step < 1 ? true : false" class="center">1</NumberCircle>
      <div class="flow123-step-text">选择BP</div>
    </div>
    <div class="flow123-line" :class="step >= 1 ? 'active' : 'disabled'"></div>
    <div class="flow123-step">
      <NumberCircle :disabled="step < 2 ? true : false" class="center">2</NumberCircle>
      <div class="flow123-step-text">完善信息</div>
    </div>
    <div class="flow123-line" :class="step >= 2 ? 'active' : 'disabled'"></div>
    <div class="flow123-step">
      <NumberCircle :disabled="step < 3 ? true : false" class="center">3</NumberCircle>
      <div class="flow123-step-text">付款</div>
    </div>
  </div>
</template>

<script>
import { NumberCircle } from './image'
export default {
  components: {
    NumberCircle
  },
  props: {
    step: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.flow123 {
  color: var(--colorGray0);
  text-align: center;
  & .flow123-step {
    display: inline-block;
    & .center {
      margin: 0 auto;
    }
    & .flow123-step-text {
      margin-top: 9px;
    }
  }
  & .flow123-line {
    display: inline-block;
    width: 50px;
    margin: 23px 20px;
    border-radius: 1px;
    border-top-width: 2px;
    border-top-style: solid;
    &.active {
      border-top-color: var(--colorMain);
    }
    &.disabled {
      border-top-color: var(--colorGray3);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Flow123.vue